import React from 'react';
import Grid from './grid';
import { getTranslation } from '../utils/config';
import ErrorMessage from '../../common-react/error-message-component';

export default function DfErrorMessage({ slim }: { slim: boolean }): React.ReactElement {
  const mailLinkAsString = `<a
    href=${'mailto:' + getTranslation('server_error_message_email')}
    target="_blank"
    title=${getTranslation('server_error_message_email')}
    rel="noreferrer"
  >${getTranslation('server_error_message_email')}</a>`;

  const message = (
    <ErrorMessage
      title={getTranslation('server_error_message_title')}
      icon="error_400"
      bodyHTML={getTranslation('server_error_message_description', mailLinkAsString)}
    ></ErrorMessage>
  );

  if (slim) {
    return message;
  } else {
    return <Grid>{message}</Grid>;
  }
}
